import React, { useMemo } from 'react';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import WidgetShell from '../../../../../ui/WidgetShell';
import { usePlanner } from '../../../contexts/PlannerContext';
import useMediaQuery from '../../../../../hooks/useMediaQuery.js';

export default function CalendarView() {
  const { tasks = [] } = usePlanner();
  const isMobile = useMediaQuery('(max-width: 640px)');

  const events = useMemo(
    () =>
      tasks.map((t) => ({
        id: t.id,
        title: t.title || 'Untitled task',
        start: t.start || t.startDate || t.dueDate || t.end,
        end: t.end || t.dueDate || t.start,
      })),
    [tasks]
  );

  const handleEventClick = (info) => {
    // Hook into existing planner detail modal when available; for now just log
    console.log('[Planner] event click', info?.event?.id);
  };

  return (
    <WidgetShell title="Calendar">
      <div className="bg-[var(--mudo-bg-soft)]/80 backdrop-blur border border-[var(--mudo-border)] rounded-xl p-2 text-[var(--mudo-text)]">
        <FullCalendar
          plugins={[dayGridPlugin, interactionPlugin]}
          initialView="dayGridMonth"
          height="auto"
          events={events}
          eventColor="var(--mudo-primary)"
          eventTextColor="var(--mudo-onPrimary)"
          eventClick={handleEventClick}
          headerToolbar={{
            left: 'prev,next today',
            center: 'title',
            right: isMobile ? '' : 'dayGridMonth,dayGridWeek,dayGridDay',
          }}
          displayEventEnd
        />
      </div>
    </WidgetShell>
  );
}
